/* eslint-disable */
/** Linting disabeld. VUE requires the _prop */

import Vue from 'vue';
import { Config } from '@/support/Config';

export default () => {
  const _prop = {
    get: () => {
      return document.title;
    },
    set: (title: string) => {
      const mainTitle = typeof Config.get('APP_TITLE') === 'string'
        ? Config.get('APP_TITLE') as string
        : 'Atabix demo';

      document.title = title ? `${mainTitle} - ${title}` : mainTitle;
    },
  };

  Object.defineProperty(Vue, 'pageTitle', _prop);
  Object.defineProperty(Vue.prototype, '$pageTitle', _prop);
};
